import {
  Component,
  OnInit,
  ChangeDetectionStrategy, Input, Output, EventEmitter, ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../../../shared/validators';
import { Property } from '../../../property/shared/models';
import { ModalComponent, Workspace } from 'app/internal/shared';
import { IntegrationProperty } from '../../shared/models/integration-property';

@Component({
  selector: 'sp-admin-property-details',
  templateUrl: './admin-property-details.component.html',
  styleUrls: ['./admin-property-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminPropertyDetailsComponent implements OnInit {

  @Input() property: Property;
  @Input() integrationProperty: IntegrationProperty;
  @Input() workspace: Workspace;
  @Output() submit = new EventEmitter<number>();

  @ViewChild('addConnectedAppModal', { static: true }) public addConnectedAppModal: ModalComponent;
  
  hasExportMap = false;

  feedbackMessages: any[] = [];
  formGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor(private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.initForm();
  }

  onSubmit() {
    // this.submit.emit(this.formGroup.value.fiscalYear);
  }

  private initForm() {
    this.formGroup.addControl('fiscalYear', this.fb.control('', [Validators.required, CustomValidators.notEmptyStringValidator]));
  }

  showAddConnectedAppModal() {
    this.addConnectedAppModal.show();
  }
}
